import { render, staticRenderFns } from "./viewPage.vue?vue&type=template&id=0d61d468&scoped=true"
import script from "./viewPage.vue?vue&type=script&lang=js"
export * from "./viewPage.vue?vue&type=script&lang=js"
import style0 from "./viewPage.vue?vue&type=style&index=0&id=0d61d468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d61d468",
  null
  
)

export default component.exports